import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    flowType: "pkce",           // OAuth redirect에서 가장 안정적인 플로우
    persistSession: true,       // 세션 localStorage 자동 저장 (앱 껐다 켜도 유지)
    autoRefreshToken: true,     // 토큰 만료 전 자동 갱신
    detectSessionInUrl: true,   // 구글 로그인 후 redirect URL에서 세션 자동 감지
  },
});
